/* global $zopim */
export function openChat () {
  $zopim.livechat.window.show()
}



// WEBPACK FOOTER //
// ./src/services/customerSupport/zopim.js